export default "__VITE_ASSET__B64MlmVM__"